import { useGoogleLogin } from '@react-oauth/google'
import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IAuthentication } from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage, getErrorMessage } from '~/@lib/utils/error.utils'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'

type Props = {
  onSuccess: (auth: IAuthentication) => void
  ambassadorCode?: string
}

function useLoginWithGoogle({ onSuccess, ambassadorCode }: Props) {
  const { setNotification } = useLocalNotifications()
  const client = useApiClientUser()

  const {
    mutate: loginWithGoogleMutation,
    isPending,
    error,
  } = useMutation({
    mutationFn: async (code: string) => {
      return client.user
        .authControllerGoogleLogin({
          code,
          redirectUri: window.location.origin,
          ambassadorCode,
        })
        .then(({ data }) => data.auth)
    },
    onSuccess,
  })

  const loginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      // codeResponse.code obsahuje authorization code
      return loginWithGoogleMutation(codeResponse.code)
    },
    onError: (error) => {
      setNotification('error', getErrorMessage(error))
    },
    flow: 'auth-code', // Dôležité: použite auth-code flow, nie implicit
  })

  return {
    loginWithGoogle,
    isRequesting: isPending,
    error: getApiErrorMessage(error, 'Prihlásenie cez Google sa nepodarilo.'),
  }
}

export { useLoginWithGoogle }
